module.exports = __webpack_public_path__ + "img/3.a9dee534.png";